import { render, staticRenderFns } from "./PPMList2.vue?vue&type=template&id=54b3e46d&scoped=true&"
import script from "./PPMList2.vue?vue&type=script&lang=ts&"
export * from "./PPMList2.vue?vue&type=script&lang=ts&"
import style0 from "./PPMList2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PPMList2.vue?vue&type=style&index=1&id=54b3e46d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b3e46d",
  null
  
)

component.options.__file = "PPMList2.vue"
export default component.exports